import React from 'react'
import { useSelector } from 'react-redux'
import CustomModal from '../common/modals/CustomModal'
import Path from "../Router/index"

function Index() {
  const {isCustomModalOpen} = useSelector(store => store.modalreducer)

  return <>
    <Path/>
    {isCustomModalOpen && <CustomModal />}  
  </> 
}

export default Index